import React, { ReactNode } from 'react';
import { ESstrings } from '../../localisation/strings.en';
import ResponsiveDialog from '../responsiveDialog';
import { getShowOkValue } from '../../utils/popupDialogHelpers';

const ConfirmationPopup = (props: any): JSX.Element => {
    const { message, show, showDialog, logOut, history, title } = props;
    return (
        <ResponsiveDialog
            imagePath={''}
            showOk={getShowOkValue(title)}
            title={title}
            message={message}
            onClose={(e: boolean) => {
                showDialog(false);
                if (title === ESstrings.Session) {
                    void logOut();
                }
                if (e !== false) {
                    //handle close and okay button on add users button
                }
            }}
            open={show}
        />
    );
};

export const BasicConfirmationPopup = (props: {
    title: string;
    message: string;
    okBtnName?: string;
    cancelBtnName?: string;
    onClose: (str: boolean) => void;
    open: boolean;
    ContentNode?: ReactNode;
    isOkEnable?: boolean;
}): JSX.Element => {
    const { title, message, onClose, open, okBtnName, cancelBtnName, ContentNode, isOkEnable } = props;
    return (
        <ResponsiveDialog
            imagePath=""
            showOk={getShowOkValue(title)}
            title={title}
            message={message}
            onClose={onClose}
            open={open}
            okBtnName={okBtnName}
            cancelBtnName={cancelBtnName}
            data-testid={title}
            ContentNode={ContentNode}
            isOkEnable={isOkEnable}
        ></ResponsiveDialog>
    );
};
export default ConfirmationPopup;
